module.exports = __webpack_public_path__ + "static/img/Michael-Gabrael.a0e5823.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Michael-Gabrael.jpg
// module id = gO6R
// module chunks = 0